import { useMemo } from 'react';
import { CheckIcon, InformationmarkSmallCircleIcon } from '@zep-us/zus-icons';
import { ParseKeys } from 'i18next';
import { useTranslation } from 'next-i18next';
import { Button, Spacing } from '@zep/ui';
export const EnterprisePlanTabsContent = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const features = useMemo(() => [
  // Basic
  t('subscription:pricing.oOskLOD6'), t('subscription:pricing.basic.spotlightUnlimited'), t('subscription:pricing.basic.screenShareUnlimited'), t('subscription:planFeatures.spaceSearchVisibility'), t('subscription:planFeatures.spacePassword'), t('subscription:pricing.basic.loginUserOnly'), t('subscription:pricing.basic.domainRestriction'), t('subscription:pricing.basic.entryTitle'),
  // Pro
  t('subscription:pricing.pro.feature5'), t('subscription:pricing.pro.feature2'), t('subscription:pricing.pro.feature4'), t('subscription:pricing.enterprise.feature2'), t('subscription:pricing.pro.visitHistoryDownload'), t('subscription:pricing.pro.messagePermission'), t('subscription:pricing.pro.spotlightParticipantVideo'), t('subscription:pricing.pro.connectionLostAlarm'),
  // Enterprise
  t('subscription:pricing.enterprise.feature3'), t('subscription:pricing.enterprise.feature4'), t('subscription:pricing.enterprise.feature5'), t('subscription:pricing.enterprise.feature6')], [t]);
  return <>
      <div className="grid w-full grid-cols-2 items-center gap-x-xs gap-y-sm rounded-[10px] border border-gray-200 bg-gray-50 px-[26px] py-[20px]">
        {features.map((feature, index) => <div key={index} className="flex items-center gap-xs">
            <span>
              <CheckIcon width={16} height={16} fill="#B8B9C8" />
            </span>
            <span className="text-[12px] font-medium text-gray-600">
              {feature as ParseKeys}
            </span>
          </div>)}
      </div>
      <Spacing size={14} data-sentry-element="Spacing" data-sentry-source-file="EnterprisePlanTabsContent.tsx" />
      <div className="flex items-center gap-3xs">
        <InformationmarkSmallCircleIcon width={14} height={14} fill={'#27262EA3'} data-sentry-element="InformationmarkSmallCircleIcon" data-sentry-source-file="EnterprisePlanTabsContent.tsx" />
        <span className="text-caption-1 font-semibold text-[#27262EA3]">
          {t('subscription:payment.duration.contactDescription')}
        </span>
        <span className="text-caption-1 font-semibold text-blue">
          <Button size="xxs" variant="white" transparent className="!text-blue" onClick={() => {
          window.open(t('subscription:subscription.salesmap.link'), '_blank');
        }} data-sentry-element="Button" data-sentry-source-file="EnterprisePlanTabsContent.tsx">
            {t('subscription:payment.duration.contact')}
          </Button>
        </span>
      </div>
    </>;
};